import Vue from 'vue'
import Router from 'vue-router'
import Trial from '../views/Trial.vue'
import NotFound from '../views/NotFound.vue'
import Result from '../views/result'
import Register from '../views/register/index'
import GuideBimmake from '../views/guide/bimmake'
import ClientTrialService from '../views/Service.vue'
import PrivacyAgreement from '../views/PrivacyAgreement.vue'
Vue.use(Router)
const routes = [
  {
    path: '/',
    redirect: {
      name: 'Trial'
    }
  },
  {
    path: '/userinfo',
    name: 'Trial',
    component: Trial
  },
  {
    path: '/get-trial',
    name: 'GetTrial',
    component: NotFound
  },
  {
    path: '/result',
    name: 'result',
    component: Result
  },
  {
    path: '/register-result',
    name: 'registerResult',
    component: Register
  },
  {
    path: '/guide-bimmake',
    name: 'guideBimmake',
    component: GuideBimmake
  },
  {
    path: "/service",
    name: "trialService",
    component: ClientTrialService
  },
  {
    path: "/privacyAgreement",
    name: "privacyAgreement",
    component: PrivacyAgreement
  }
]

const router = new Router({
  routes
})

export default router
